var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import Accordion from '@/components/Accordion.vue';
import { listMeetimeCadences, listMeetimeOwners } from '@/clients/crm';
import Tooltip from 'src/components/Tooltip.vue';
let MeetimeCadenceConfig = class MeetimeCadenceConfig extends Vue {
    constructor() {
        super(...arguments);
        this.cadenceNameSelected = '';
        this.candences = [];
        this.owners = [];
        this.missingCnpjMeetimeField = false;
        this.loaded = false;
        this.selectedCadence = null;
        this.selectedOwner = null;
    }
    async mounted() {
        this.getCandences();
        this.getOwners();
        this.loaded = true;
    }
    async getCandences() {
        try {
            const result = await listMeetimeCadences();
            this.candences = result.data || [];
        }
        catch (e) {
            console.log(e);
        }
    }
    async getOwners() {
        try {
            const result = await listMeetimeOwners();
            this.owners = result.data || [];
        }
        catch (e) {
            console.log(e);
        }
    }
    cadenceNames() {
        return this.candences.map(c => c.name);
    }
    cadenceSelected() {
        const cadence = this.candences.find(c => c.name == this.cadenceNameSelected);
        if (cadence) {
            this.selectedCadence = cadence.id;
            this.changeCadenceConfig();
        }
    }
    ownerSelected() {
        this.changeCadenceConfig();
    }
    changeCadenceConfig() {
        this.$emit('changeCadenceConfig', {
            cadence: this.selectedCadence,
            owner: this.selectedOwner,
        });
    }
};
MeetimeCadenceConfig = __decorate([
    Component({
        name: 'MeetimeCadenceConfig',
        components: {
            Accordion,
            Tooltip,
        },
    })
], MeetimeCadenceConfig);
export default MeetimeCadenceConfig;
